import Axios from 'axios'
import persistentData from '@/plugins/persistentData'
import moment from 'moment'

const InterceptorAPI = {
  validateVersionFront(version) {
    const setDataAndReload = (v, reload) => {
      persistentData.setData('x-web-v', v, false)
      if (reload) window.location.reload(true)
    }
    const version_now = persistentData.getData('x-web-v', false)
    if (version_now) {
      // Compare version
      if (version_now !== version) setDataAndReload(version, true)
    } else if (version != '') {
      setDataAndReload(version, false)
    }
  },
  getHeaders() {
    const params = {
      "Content-Type": "application/json"
    }
    const token = persistentData.getData('token') 
    if (token) params.Authorization = `Bearer ${token}` 
    
    return params
  },
  async validateToken() {
    const self = this
    const expired = moment(persistentData.getData('tokenExpiration'))
    if (expired.diff(moment(), 'm') < 1) {
      await self.refreshToken()
    }
    return true
  },
  async refreshToken() {
    try {
      const response = await Axios.post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SECURITY}/refreshToken`, {'Value': persistentData.getData('token', false)})
      if (response.status == 200) {
        persistentData.setData("tokenExpiration", response.data.tokenExpiration)
        persistentData.setData("token", response.data.token)
        return response
      } else {
        persistentData.removeData('token')
        persistentData.removeData('tokenExpiration')
        persistentData.removeData('fullName')
        window.mainApp.$router.push(`/login`)
      }
    } catch (error) {
      persistentData.removeData('token')
      persistentData.removeData('tokenExpiration')
      persistentData.removeData('fullName')
      window.mainApp.$router.push(`/login`)
    }
  },
  async get(endpoint) {
    const self = this
    try {
      await self.validateToken() 
      try {
        const response = await Axios.get(endpoint, { headers: self.getHeaders() })
        if(response.headers['x-web-v']) self.validateVersionFront(response.headers['x-web-v'])
        return response
      } catch (errorResponse) {
        if (errorResponse.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.get(endpoint, { headers: self.getHeaders() })
              return response
            }
          } catch (errorToken) {
            console.error(errorToken)
          }
        }
      }
    } catch(errorToken) {
      console.error(errorToken)
    }
  },
  async post(endpoint, data) {
    const self = this
    try {
      await self.validateToken()
      try {
        const response = await Axios.post(endpoint, data, { headers: self.getHeaders() })
        return response
      } catch (error) {
        if (error.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.post(endpoint, data, { headers: self.getHeaders() })
              return response
            }
          } catch (error) {
            if (error.response.data == 'InvalidGameOrTeam' || error.response.data == 'OtherActionRunning' || error.response.data == 'NotManaged') {
              window.mainApp.$store.dispatch("openModalError", error.response.data)
            } else {
              console.log(error);
            }
          }
        } else {
          if (error.response.data == 'InvalidGameOrTeam' || error.response.data == 'OtherActionRunning' || error.response.data == 'NotManaged') {
            window.mainApp.$store.dispatch("openModalError", error.response.data)
          } else {
            console.log(error);
          }
        }
      }
    } catch (error) {
      if (error.response.data == 'InvalidGameOrTeam' || error.response.data == 'OtherActionRunning' || error.response.data == 'NotManaged') {
        window.mainApp.$store.dispatch("openModalError", error.response.data)
      } else {
        console.log(error);
      }
    }
  },
  async put(endpoint, data) {
    const self = this
    try {
      await self.validateToken()
      try {
        const response = await Axios.put(endpoint, data, { headers: self.getHeaders() })
        return response
      } catch (error) {
        console.log(error)
        if (error.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.put(endpoint, data, { headers: self.getHeaders() })
              return response
            }
          } catch (error) {
            console.error(error)
          }
        }
      }
    } catch (error) {
      console.error(error)
    }
  },
  async delete(endpoint) {
    const self = this
    try {
      await self.validateToken()
      try {
        const response = await Axios.delete(endpoint, { headers: self.getHeaders() })
        return response
      } catch (error) {
        console.log(error)
        if (error.response.status == 401) {
          // Refresh token
          try {
            const token = await self.refreshToken()
            if (token) {
              const response = await Axios.delete(endpoint, { headers: self.getHeaders() })
              return response
            }
          } catch (error) {
            console.error(error)
          }
        }
      }
    } catch (error) {
      console.error(error)
    }
  },
  async postWithoutToken(endpoint, data) {
    const self = this
    try {
      const response = await Axios.post(endpoint, data, { headers: self.getHeaders() })
      return response
    } catch (error) {
      window.mainApp.$notify({
        message: error.response.data,
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    }
  }
}

export default InterceptorAPI